exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".rating-panel{border:1px solid #eee !important}.rating-panel .panel-heading{padding-bottom:0}.rating-panel .panel-heading h3{margin-bottom:0}.rating-panel .panel-body{padding-top:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./modules/rating/css/recipe-rating-wrapper.scss
// module id = 687
// module chunks = 0